/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Answer
 */
export interface Answer {
    /**
     * 
     * @type {number}
     * @memberof Answer
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Answer
     */
    question: number;
    /**
     * 
     * @type {string}
     * @memberof Answer
     */
    response: string;
    /**
     * 
     * @type {string}
     * @memberof Answer
     */
    readonly elementScore: string;
    /**
     * 
     * @type {string}
     * @memberof Answer
     */
    readonly globalScore: string;
}

/**
 * Check if a given object implements the Answer interface.
 */
export function instanceOfAnswer(value: object): value is Answer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('question' in value) || value['question'] === undefined) return false;
    if (!('response' in value) || value['response'] === undefined) return false;
    if (!('elementScore' in value) || value['elementScore'] === undefined) return false;
    if (!('globalScore' in value) || value['globalScore'] === undefined) return false;
    return true;
}

export function AnswerFromJSON(json: any): Answer {
    return AnswerFromJSONTyped(json, false);
}

export function AnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Answer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'question': json['question'],
        'response': json['response'],
        'elementScore': json['element_score'],
        'globalScore': json['global_score'],
    };
}

  export function AnswerToJSON(json: any): Answer {
      return AnswerToJSONTyped(json, false);
  }

  export function AnswerToJSONTyped(value?: Omit<Answer, 'id'|'element_score'|'global_score'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'response': value['response'],
    };
}

